<template>
  <v-dialog
    :value="value"
    persistent
    max-width="500"
  >
    <v-card>
      <v-card-title class="text-h5" v-html="$store.state.dialog.title" />

      <v-card-text v-html="$store.state.dialog.text" />
      <section
        v-if="$store.state.dialog.checkbox?.show"
        class="
          d-flex justify-end
          px-6
          text-right secondary
        "
      >
        <v-checkbox
          v-model="checked"
          class="text-right"
          :label="$store.state.dialog.checkbox.label"
        />
      </section>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          :disabled="disabledButtons"
          @click="handleDisagree"
        >
          {{ $store.state.dialog.disagreeText || 'Annuler' }}
        </v-btn>
        <v-btn
          color="primary"
          text
          :disabled="disabledButtons"
          @click="handleAccept"
        >
          {{ $store.state.dialog.acceptText || 'Accepter' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'Dialog',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      checked: this.$store.state.dialog.checkbox?.show ? this.$store.state.dialog.checkbox.checked : null,
      disabledButtons: false
    };
  },
  methods: {
    async handleAccept () {
      this.disabledButtons = true;
      if (this.$store.state.dialog.handleAccept) await this.$store.state.dialog.handleAccept(this.$store.state.dialog.checkbox?.show ? this.checked : null);

      this.closeDialog();
      this.checked = null;
      this.disabledButtons = false;
    },
    handleDisagree () {
      this.disabledButtons = true;
      if (this.$store.state.dialog.handleDisagree) this.this.$store.state.dialog.handleDisagree();

      this.closeDialog();
      this.checked = null;
      this.disabledButtons = false;
    },
    closeDialog () {
      this.$emit('input', false);
      this.$emit('close-dialog', { show: false });
    }
  }
};
</script>
